import React from 'react'
import { get, debounce } from 'lodash'

import { AutoComplete } from 'material-ui'
import api from '../api'

export class AutoCompleteField extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      searchText: '',
      dataSource: [],
      settingsDataSource: []
    }

// @ts-ignore
    this.searchApiDebounced = debounce(this.searchApi.bind(this), 400)
  }

  componentDidMount () {
    if (this.props.field.setting) {
      api
        .get('admin/settings')
        .then(res => res.json())
        .then(res => {
          const dataSource = (get(((res || []).find(s => s.key === this.props.field.setting)), 'value') || [])
          this.setState({
            dataSource: dataSource,
            settingsDataSource: dataSource,
            searchText: get(dataSource.find(r => get(r, this.props.field.valueProp) === this.props.value), this.props.field.displayProp)
          })
        })
    } else {
      if (this.props.value) {
        // @ts-ignore
        this.searchApi({
          id: this.props.value
        }).then(res => {
          this.setState({
            searchText: get(res.find(r => get(r, this.props.field.valueProp) === this.props.value), this.props.field.displayProp)
          })
        })
      }
    }
  }

  searchApi ({ searchText, id }) {
    if (this.props.field.setting) {
      this.setState({
        dataSource: (this.state.settingsDataSource || []).filter(
          item => AutoComplete.fuzzyFilter(searchText, item[this.props.field.displayProp])
        )
      })
      return Promise.resolve()
    }

    const apiQuery = {
      filters: {
        [`${this.props.field.displayProp}_ilike`]: searchText,
        ids: [id],
        not_ids: this.props.field.excludeIds
      },
      limit: 100,
      order: [{ column: 'id', direction: 'asc' }]
    }

    if (this.props.field.query && this.props.field.query.filters) {
      apiQuery.filters = {
        ...apiQuery.filters,
        ...this.props.field.query.filters
      }
    }

    return api
      .get(this.props.field.apiPath, { body: apiQuery })
      .then(res => res.json())
      .then(res => {
        this.setState({
          dataSource: res
        })
        return res
      })
  }

  handleUpdateInput (searchText) {
    this.setState({
      searchText
    })
// @ts-ignore
    this.searchApiDebounced({ searchText })
  }

  handleSelection (chosenRequest) {
    this.props.onChange && this.props.onChange(get(chosenRequest, this.props.field.valueProp))
  }

  render () {
    return (
      <AutoComplete
        fullWidth
        openOnFocus
        floatingLabelText={`${this.props.field.name} ${this.props.value ? '#' + this.props.value : ''}`}
        dataSource={this.state.dataSource}
        dataSourceConfig={{ text: this.props.field.displayProp, value: this.props.field.valueProp }}
        onNewRequest={this.handleSelection.bind(this)}
        filter={() => true}
        errorText={this.props.errorText}
        searchText={this.state.searchText}
        onUpdateInput={this.handleUpdateInput.bind(this)}
        listStyle={{ maxHeight: '300px', overflow: 'auto' }}
        onClose={e => {
          if (this.props.value && !this.state.searchText) {
            this.props.onChange(null)
          }
        }}
      />
    )
  }
}

export default AutoCompleteField
